import Loadable from 'components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const Inquiry = Loadable(lazy(() => import('./index')))
const List = Loadable(lazy(() => import('./list/index')))
const Form = Loadable(lazy(() => import('./form/index')))

const Approval = Loadable(lazy(() => import('./approval/index')))
const ApprovalForm = Loadable(lazy(() => import('./approval/form/index')))

const Laporan = Loadable(lazy(() => import('./laporan/index')))

export const routes: RouteObject[] = [
    {
        path: '/list/kelola-nasabah/kelola-akun-direct-debit',
        children: [
            {
                index: true,
                element: <Inquiry />,
            },
            {
                path: ':customerId',
                element: <List />,
            }
        ]
    },

    {
        path: '/form/kelola-nasabah/kelola-akun-direct-debit/:customerId/:bankCardToken',
        element: <Form />,
    },

    {
        path: '/list/persetujuan/kelola-akun-direct-debit',
        element: <Approval />
    },
    {
        path: '/form/persetujuan/kelola-akun-direct-debit/:id',
        element: <ApprovalForm />,
    },

    {
        path: '/laporan/kelola-akun-direct-debit',
        element: <Laporan />,
    },
];
